import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { TintoaConfigProvider } from '@tintoa/ui';
import { AppThemeProvider } from './theme/ThemeContext';
import Routes from './Routes';
import { SnackbarProvider } from 'notistack';

// Same-origin: the identity service serves this frontend, so its API and the
// `/app/*` pages live under the current origin.
const identityServiceUrl =
  typeof window !== 'undefined' ? window.location.origin : '';

function App() {
  return (
    <TintoaConfigProvider
      identityServiceUrl={identityServiceUrl}
      clientId="identity-account"
    >
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <BrowserRouter>
          <AppThemeProvider>
            <CssBaseline />
            <Routes />
          </AppThemeProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </TintoaConfigProvider>
  );
}

export default App;
